import { useMemo } from "react";
import { useSelector } from "react-redux";

import { Slide } from "pwapi";

import { SysState } from "../reducers/sysReducer";

export const useViewableSlideStatuses = () => {
  const canViewNonSuccessSlides = useSelector(
    ({ sys }: { sys: SysState }) => sys.features.canViewNonSuccessSlides
  );

  return useMemo(() => {
    const viewableSlideStatuses = [Slide.status.SUCCESS];

    if (canViewNonSuccessSlides) {
      return Object.values(Slide.status);
    }

    return viewableSlideStatuses;
  }, [canViewNonSuccessSlides]);
};
